module.exports = __webpack_public_path__ + "img/thumb_14.7bef0541.jpg";